module.exports = __webpack_public_path__ + "img/icons8-done.e902e5f9.svg";